import React from "react";
import OrderForm from "./OrderForm";
const FormContainer = ({props}) => {
  return (
    <div className="col-lg-6 cart_col">
      <div id='submitFormDiv' className="cart_total">
        <div id='cartDetails' className="cart_extra_content cart_extra_total">
          <div className="checkout_title">Cart Total</div>
          <ul className="cart_extra_total_list">
            <li className="d-flex flex-row align-items-center justify-content-start">
              <div className="cart_extra_total_title">Subtotal</div>
              <div className="cart_extra_total_value ml-auto">{props.designer.price}</div>
            </li>
            <li className="d-flex flex-row align-items-center justify-content-start">
              <div className="cart_extra_total_title">Shipping</div>
              <div className="cart_extra_total_value ml-auto">free</div>
            </li>
            <li className="d-flex flex-row align-items-center justify-content-start">
              <div className="cart_extra_total_title">Total</div>
              <div className="cart_extra_total_value ml-auto">{parseInt(props.designer.price)}</div>
            </li>
          </ul>
        </div>
        <OrderForm props={props}/>
      </div>
    </div>
  );
};

export default FormContainer;
